import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Alert,
  Button,
  Typography,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PanelPage2 from "../pages/PanelPage2";
import { useAuth } from "../context/AuthContext";

export default function DashboardPage() {
  const [alojamiento, setAlojamiento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getDashboardData } = useAuth();

  const cargarDashboard = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getDashboardData();

      if (data) {
        setAlojamiento(data);
      } else {
        setAlojamiento(null);
        setError("No se encontró información del alojamiento.");
      }
    } catch (err) {
      setAlojamiento(null);
      setError("Error al cargar el dashboard.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Loading full-screen
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, md: 4 },
          bgcolor: "#F5F5F5",
        }}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  // Error / no data screen (multiplataforma)
  if (error || !alojamiento) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#F5F5F5",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 2, md: 4 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 720,
            textAlign: "center",
            px: { xs: 2, sm: 4 },
            py: { xs: 3, sm: 4 },
          }}
        >
          <Alert
            severity="error"
            sx={{
              mb: { xs: 2, sm: 3 },
              fontSize: { xs: "0.95rem", sm: "1.05rem" },
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{ mb: 0 }}
            >
              {error || "Información no disponible"}
            </Typography>
          </Alert>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: { xs: 2.5, sm: 3 } }}
          >
            Este apartado aún no fue implementado en tu sistema. Por favor,
            comunícate con el implementador a cargo o envíanos un mensaje
            directo a WhatsApp para recibir asistencia.
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              onClick={cargarDashboard}
              sx={{
                bgcolor: "#903AF2",
                color: "#fff",
                fontWeight: "bold",
                px: 3,
                py: 1.2,
                borderRadius: 3,
                "&:hover": { bgcolor: "#7e2fde" },
                width: { xs: "100%", sm: "auto" },
              }}
            >
              Reintentar
            </Button>

            <Button
              variant="contained"
              startIcon={<WhatsAppIcon />}
              sx={{
                bgcolor: "#25D366",
                color: "#fff",
                fontWeight: "bold",
                px: 3,
                py: 1.2,
                borderRadius: 3,
                "&:hover": { bgcolor: "#1ebe5d" },
                width: { xs: "100%", sm: "auto" },
              }}
              href="https://wa.me/542604206967"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contactar por WhatsApp
            </Button>
          </Box>
        </Box>
      </Box>
    );
  }

  // Data OK → render del panel
  return (
    <PanelPage2 data={alojamiento} refetchAlojamiento={cargarDashboard} />
  );
}
